var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},_vm._l((this.$root.notifications),function(alert){return _c('Notification',{key:alert.id+alert.message,attrs:{"message":alert.message,"heading":alert.heading,"type":alert.type,"id":alert.id,"dissmiss":()=>_vm.removeIt(alert.id)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }